/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
const list = [
	{ code: '_somaliland', label: t('privacy', 'Somaliland') },
	{ code: 'ad', label: t('privacy', 'Andorra') },
	{ code: 'ae', label: t('privacy', 'United Arab Emirates') },
	{ code: 'af', label: t('privacy', 'Afghanistan') },
	{ code: 'ag', label: t('privacy', 'Antigua and Barbuda') },
	{ code: 'ai', label: t('privacy', 'Anguilla') },
	{ code: 'al', label: t('privacy', 'Albania') },
	{ code: 'am', label: t('privacy', 'Armenia') },
	{ code: 'ao', label: t('privacy', 'Angola') },
	{ code: 'aq', label: t('privacy', 'Antarctica') },
	{ code: 'ar', label: t('privacy', 'Argentina') },
	{ code: 'as', label: t('privacy', 'American Samoa') },
	{ code: 'at', label: t('privacy', 'Austria') },
	{ code: 'au', label: t('privacy', 'Australia') },
	{ code: 'aw', label: t('privacy', 'Aruba') },
	{ code: 'ax', label: t('privacy', 'Åland Islands') },
	{ code: 'az', label: t('privacy', 'Azerbaijan') },
	{ code: 'ba', label: t('privacy', 'Bosnia and Herzegovina') },
	{ code: 'bb', label: t('privacy', 'Barbados') },
	{ code: 'bd', label: t('privacy', 'Bangladesh') },
	{ code: 'be', label: t('privacy', 'Belgium') },
	{ code: 'bf', label: t('privacy', 'Burkina Faso') },
	{ code: 'bg', label: t('privacy', 'Bulgaria') },
	{ code: 'bh', label: t('privacy', 'Bahrain') },
	{ code: 'bi', label: t('privacy', 'Burundi') },
	{ code: 'bj', label: t('privacy', 'Benin') },
	{ code: 'bl', label: t('privacy', 'Saint Barthélemy') },
	{ code: 'bm', label: t('privacy', 'Bermuda') },
	{ code: 'bn', label: t('privacy', 'Brunei') },
	{ code: 'bo', label: t('privacy', 'Bolivia') },
	{ code: 'bq', label: t('privacy', 'Bonaire, Sint Eustatius and Saba') },
	{ code: 'br', label: t('privacy', 'Brazil') },
	{ code: 'bs', label: t('privacy', 'Bahamas') },
	{ code: 'bt', label: t('privacy', 'Bhutan') },
	{ code: 'bv', label: t('privacy', 'Bouvet Island') },
	{ code: 'bw', label: t('privacy', 'Botswana') },
	{ code: 'by', label: t('privacy', 'Belarus') },
	{ code: 'bz', label: t('privacy', 'Belize') },
	{ code: 'ca', label: t('privacy', 'Canada') },
	{ code: 'cc', label: t('privacy', 'Cocos (Keeling) Islands') },
	{ code: 'cd', label: t('privacy', 'Democratic Republic of the Congo') },
	{ code: 'cf', label: t('privacy', 'Central African Republic') },
	{ code: 'cg', label: t('privacy', 'Congo') },
	{ code: 'ch', label: t('privacy', 'Switzerland') },
	{ code: 'ci', label: t('privacy', 'Cote d\'Ivoire') },
	{ code: 'ck', label: t('privacy', 'Cook Islands') },
	{ code: 'cl', label: t('privacy', 'Chile') },
	{ code: 'cm', label: t('privacy', 'Cameroon') },
	{ code: 'cn', label: t('privacy', 'China') },
	{ code: 'co', label: t('privacy', 'Colombia') },
	{ code: 'cr', label: t('privacy', 'Costa Rica') },
	{ code: 'cu', label: t('privacy', 'Cuba') },
	{ code: 'cv', label: t('privacy', 'Cabo Verde') },
	{ code: 'cw', label: t('privacy', 'Curaçao') },
	{ code: 'cx', label: t('privacy', 'Christmas Island') },
	{ code: 'cy', label: t('privacy', 'Cyprus') },
	{ code: 'cz', label: t('privacy', 'Czech') },
	{ code: 'de', label: t('privacy', 'Germany') },
	{ code: 'dj', label: t('privacy', 'Djibouti') },
	{ code: 'dk', label: t('privacy', 'Denmark') },
	{ code: 'do', label: t('privacy', 'Dominican Republic') },
	{ code: 'dz', label: t('privacy', 'Algeria') },
	{ code: 'ec', label: t('privacy', 'Ecuador') },
	{ code: 'ee', label: t('privacy', 'Estonia') },
	{ code: 'eg', label: t('privacy', 'Egypt') },
	{ code: 'eh', label: t('privacy', 'West Sahara') },
	{ code: 'er', label: t('privacy', 'Eritrea') },
	{ code: 'es', label: t('privacy', 'Spain') },
	{ code: 'et', label: t('privacy', 'Ethiopia') },
	{ code: 'fi', label: t('privacy', 'Finland') },
	{ code: 'fj', label: t('privacy', 'Fiji') },
	{ code: 'fk', label: t('privacy', 'Falkland Islands') },
	{ code: 'fm', label: t('privacy', 'Micronesia') },
	{ code: 'fo', label: t('privacy', 'Faroe Islands') },
	{ code: 'fr', label: t('privacy', 'France') },
	{ code: 'ga', label: t('privacy', 'Gabon') },
	{ code: 'gb', label: t('privacy', 'United Kingdom') },
	{ code: 'gd', label: t('privacy', 'Grenada') },
	{ code: 'ge', label: t('privacy', 'Georgia') },
	{ code: 'gf', label: t('privacy', 'French Guiana') },
	{ code: 'gg', label: t('privacy', 'Guernsey') },
	{ code: 'gh', label: t('privacy', 'Ghana') },
	{ code: 'gi', label: t('privacy', 'Gibraltar') },
	{ code: 'gl', label: t('privacy', 'Greenland') },
	{ code: 'gm', label: t('privacy', 'Gambia') },
	{ code: 'gn', label: t('privacy', 'Guinea') },
	{ code: 'gp', label: t('privacy', 'Guadeloupe') },
	{ code: 'gq', label: t('privacy', 'Equatorial Guinea') },
	{ code: 'gr', label: t('privacy', 'Greece') },
	{ code: 'gs', label: t('privacy', 'South Georgia and the South Sandwich Islands') },
	{ code: 'gt', label: t('privacy', 'Guatemala') },
	{ code: 'gu', label: t('privacy', 'Guam') },
	{ code: 'gw', label: t('privacy', 'Guinea-Bissau') },
	{ code: 'gy', label: t('privacy', 'Guyana') },
	{ code: 'hk', label: t('privacy', 'Hong Kong') },
	{ code: 'hm', label: t('privacy', 'Heard Island and McDonald Islands') },
	{ code: 'hn', label: t('privacy', 'Honduras') },
	{ code: 'hr', label: t('privacy', 'Croatia') },
	{ code: 'ht', label: t('privacy', 'Haiti') },
	{ code: 'hu', label: t('privacy', 'Hungary') },
	{ code: 'id', label: t('privacy', 'Indonesia') },
	{ code: 'ie', label: t('privacy', 'Ireland') },
	{ code: 'il', label: t('privacy', 'Israel') },
	{ code: 'im', label: t('privacy', 'Isle of Man') },
	{ code: 'in', label: t('privacy', 'India') },
	{ code: 'io', label: t('privacy', 'British Indian Ocean Territory') },
	{ code: 'iq', label: t('privacy', 'Iraq') },
	{ code: 'ir', label: t('privacy', 'Iran') },
	{ code: 'is', label: t('privacy', 'Iceland') },
	{ code: 'it', label: t('privacy', 'Italy') },
	{ code: 'jm', label: t('privacy', 'Jamaica') },
	{ code: 'jo', label: t('privacy', 'Jordan') },
	{ code: 'jp', label: t('privacy', 'Japan') },
	{ code: 'ke', label: t('privacy', 'Kenya') },
	{ code: 'kg', label: t('privacy', 'Kyrgyzstan') },
	{ code: 'kh', label: t('privacy', 'Cambodia') },
	{ code: 'ki', label: t('privacy', 'Kiribati') },
	{ code: 'km', label: t('privacy', 'Comores') },
	{ code: 'kn', label: t('privacy', 'Saint Kitts and Nevis') },
	{ code: 'kp', label: t('privacy', 'North Korea') },
	{ code: 'kr', label: t('privacy', 'South Korea') },
	{ code: 'kw', label: t('privacy', 'Kuwait') },
	{ code: 'ky', label: t('privacy', 'Cayman Islands') },
	{ code: 'kz', label: t('privacy', 'Kazakhstan') },
	{ code: 'la', label: t('privacy', 'Laos') },
	{ code: 'lb', label: t('privacy', 'Lebanon') },
	{ code: 'lc', label: t('privacy', 'Saint Lucia') },
	{ code: 'li', label: t('privacy', 'Liechtenstein') },
	{ code: 'lk', label: t('privacy', 'Sri Lanka') },
	{ code: 'lr', label: t('privacy', 'Liberia') },
	{ code: 'ls', label: t('privacy', 'Lesotho') },
	{ code: 'lt', label: t('privacy', 'Lithuania') },
	{ code: 'lu', label: t('privacy', 'Luxembourg') },
	{ code: 'lv', label: t('privacy', 'Latvia') },
	{ code: 'ly', label: t('privacy', 'Libya') },
	{ code: 'ma', label: t('privacy', 'Morocco') },
	{ code: 'mc', label: t('privacy', 'Monaco') },
	{ code: 'md', label: t('privacy', 'Moldova') },
	{ code: 'me', label: t('privacy', 'Montenegro') },
	{ code: 'mf', label: t('privacy', 'Saint Martin') },
	{ code: 'mg', label: t('privacy', 'Madagascar') },
	{ code: 'mh', label: t('privacy', 'Marshall Islands') },
	{ code: 'mk', label: t('privacy', 'Macedonia') },
	{ code: 'ml', label: t('privacy', 'Mali') },
	{ code: 'mm', label: t('privacy', 'Myanmar') },
	{ code: 'mn', label: t('privacy', 'Mongolia') },
	{ code: 'mo', label: t('privacy', 'Macao') },
	{ code: 'mp', label: t('privacy', 'Northern Mariana Islands') },
	{ code: 'mr', label: t('privacy', 'Mauritania') },
	{ code: 'ms', label: t('privacy', 'Montserrat') },
	{ code: 'mt', label: t('privacy', 'Malta') },
	{ code: 'mu', label: t('privacy', 'Mauritius') },
	{ code: 'mv', label: t('privacy', 'Maldives') },
	{ code: 'mw', label: t('privacy', 'Malawi') },
	{ code: 'mx', label: t('privacy', 'Mexico') },
	{ code: 'my', label: t('privacy', 'Malaysia') },
	{ code: 'mz', label: t('privacy', 'Mozambique') },
	{ code: 'na', label: t('privacy', 'Namibia') },
	{ code: 'nc', label: t('privacy', 'New Caledonia') },
	{ code: 'ne', label: t('privacy', 'Niger') },
	{ code: 'nf', label: t('privacy', 'Norfolk Island') },
	{ code: 'ng', label: t('privacy', 'Nigeria') },
	{ code: 'ni', label: t('privacy', 'Nicaragua') },
	{ code: 'nl', label: t('privacy', 'Netherlands') },
	{ code: 'no', label: t('privacy', 'Norway') },
	{ code: 'np', label: t('privacy', 'Nepal') },
	{ code: 'nr', label: t('privacy', 'Nauru') },
	{ code: 'nu', label: t('privacy', 'Niue') },
	{ code: 'nz', label: t('privacy', 'New Zealand') },
	{ code: 'om', label: t('privacy', 'Oman') },
	{ code: 'pa', label: t('privacy', 'Panama') },
	{ code: 'pe', label: t('privacy', 'Peru') },
	{ code: 'pf', label: t('privacy', 'French Polynesia') },
	{ code: 'pg', label: t('privacy', 'Papua New Guinea') },
	{ code: 'ph', label: t('privacy', 'Philippines') },
	{ code: 'pk', label: t('privacy', 'Pakistan') },
	{ code: 'pl', label: t('privacy', 'Poland') },
	{ code: 'pm', label: t('privacy', 'Saint Pierre and Miquelon') },
	{ code: 'pn', label: t('privacy', 'Pitcairn') },
	{ code: 'pr', label: t('privacy', 'Puerto Rico') },
	{ code: 'ps', label: t('privacy', 'Palestine') },
	{ code: 'pt', label: t('privacy', 'Portugal') },
	{ code: 'pw', label: t('privacy', 'Palau') },
	{ code: 'py', label: t('privacy', 'Paraguay') },
	{ code: 'qa', label: t('privacy', 'Qatar') },
	{ code: 're', label: t('privacy', 'Réunion') },
	{ code: 'ro', label: t('privacy', 'Romania') },
	{ code: 'rs', label: t('privacy', 'Serbia') },
	{ code: 'ru', label: t('privacy', 'Russia') },
	{ code: 'rw', label: t('privacy', 'Rwanda') },
	{ code: 'sa', label: t('privacy', 'Saudi Arabia') },
	{ code: 'sb', label: t('privacy', 'Solomon Islands') },
	{ code: 'sc', label: t('privacy', 'Seychelles') },
	{ code: 'sd', label: t('privacy', 'Sudan') },
	{ code: 'se', label: t('privacy', 'Sweden') },
	{ code: 'sg', label: t('privacy', 'Singapore') },
	{ code: 'sh', label: t('privacy', 'Saint Helena, Ascension and Tristan da Cunha') },
	{ code: 'si', label: t('privacy', 'Slovenia') },
	{ code: 'sj', label: t('privacy', 'Svalbard and Jan Mayen') },
	{ code: 'sk', label: t('privacy', 'Slovakia') },
	{ code: 'sl', label: t('privacy', 'Sierra Leone') },
	{ code: 'sm', label: t('privacy', 'San Marino') },
	{ code: 'sn', label: t('privacy', 'Senegal') },
	{ code: 'so', label: t('privacy', 'Somalia') },
	{ code: 'sr', label: t('privacy', 'Suriname') },
	{ code: 'ss', label: t('privacy', 'South Sudan') },
	{ code: 'st', label: t('privacy', 'Sao Tome and Principe') },
	{ code: 'sv', label: t('privacy', 'El Salvador') },
	{ code: 'sx', label: t('privacy', 'Sint Maarten') },
	{ code: 'sy', label: t('privacy', 'Syria') },
	{ code: 'sz', label: t('privacy', 'Swaziland') },
	{ code: 'tc', label: t('privacy', 'Turks and Caicos Islands') },
	{ code: 'td', label: t('privacy', 'Chad') },
	{ code: 'tf', label: t('privacy', 'Fr. S. Antarctic Lands') },
	{ code: 'tg', label: t('privacy', 'Togo') },
	{ code: 'th', label: t('privacy', 'Thailand') },
	{ code: 'tj', label: t('privacy', 'Tajikistan') },
	{ code: 'tk', label: t('privacy', 'Tokelau') },
	{ code: 'tl', label: t('privacy', 'Timor-Leste') },
	{ code: 'tm', label: t('privacy', 'Turkmenistan') },
	{ code: 'tn', label: t('privacy', 'Tunisia') },
	{ code: 'to', label: t('privacy', 'Tonga') },
	{ code: 'tr', label: t('privacy', 'Turkey') },
	{ code: 'tt', label: t('privacy', 'Trinidad and Tobago') },
	{ code: 'tv', label: t('privacy', 'Tuvalu') },
	{ code: 'tw', label: t('privacy', 'Taiwan') },
	{ code: 'tz', label: t('privacy', 'Tanzania') },
	{ code: 'ua', label: t('privacy', 'Ukraine') },
	{ code: 'ug', label: t('privacy', 'Uganda') },
	{ code: 'um', label: t('privacy', 'United States Minor Outlying Islands') },
	{ code: 'us', label: t('privacy', 'United States') },
	{ code: 'uy', label: t('privacy', 'Uruguay') },
	{ code: 'uz', label: t('privacy', 'Uzbekistan') },
	{ code: 'va', label: t('privacy', 'Holy See') },
	{ code: 'vc', label: t('privacy', 'Saint Vincent and the Grenadines') },
	{ code: 've', label: t('privacy', 'Venezuela') },
	{ code: 'vg', label: t('privacy', 'Virgin Islands (British)') },
	{ code: 'vi', label: t('privacy', 'Virgin Islands (U.S.)') },
	{ code: 'vn', label: t('privacy', 'Vietnam') },
	{ code: 'vu', label: t('privacy', 'Vanuatu') },
	{ code: 'wf', label: t('privacy', 'Wallis and Futuna') },
	{ code: 'ws', label: t('privacy', 'Samoa') },
	{ code: 'ye', label: t('privacy', 'Yemen') },
	{ code: 'yt', label: t('privacy', 'Mayotte') },
	{ code: 'za', label: t('privacy', 'South Africa') },
	{ code: 'zm', label: t('privacy', 'Zambia') },
	{ code: 'zw', label: t('privacy', 'Zimbabwe') },
]

/**
 *
 */
export function getCountryList() {
	return list.sort((a, b) => a.label < b.label ? -1 : 1)
}

/**
 * @param code
 */
export function getNameForCountryCode(code) {
	const element = list.find((e) => e.code === code)
	if (element) {
		return element.label
	}

	return ''
}
